export const PAGES_RESET_STATE = 'PAGES_RESET_STATE';
export const PAGES_CURRENT_ITEM = 'PAGES_CURRENT_ITEM';

export const PAGES_REQUEST_LOADING = 'PAGES_REQUEST_LOADING';
export const PAGES_REQUEST_SUCCESS = 'PAGES_REQUEST_SUCCESS';
export const PAGES_REQUEST_FAILED = 'PAGES_REQUEST_FAILED';

export const PAGES_CURRENT_ACTION = 'PAGES_CURRENT_ACTION';
export const PAGES_RESET_ACTION = 'PAGES_RESET_ACTION';